import GoogleMapReact, { ChildComponentProps, ClickEventValue, Coords, MapOptions } from 'google-map-react';
import { connect } from 'react-redux';

import classNames from 'classnames';
import React, { useEffect, useReducer } from 'react';
import { useTranslation } from 'react-i18next';
import { bindActionCreators } from 'redux';
import * as AppService from '../../../common/services/app/Service';
import * as Actions from '../../../common/services/subscription/Actions';
import { GeolocationsDTO } from '../../../common/types/dto/GeolocationsDTO';
import { RootState } from '../../base';
import { config } from '../../common/';
import { AppThunkDispatch } from '../../common/types';
import css from './Maps.scss';

interface MapsState {
    geolocations: GeolocationsDTO[];
    filteredGeolocations: GeolocationsDTO[];
    showingInfoWindow: boolean;
    activeMarker: GeolocationsDTO | null;
    showDealers: boolean;
    showDealersCarWash: boolean;
    showBP: boolean;
    showBPCarWash: boolean;
    showHP: boolean;
}

interface ReduxStateProps {
    geolocations: GeolocationsDTO[];
    isCommunicatingGetGeolocations: boolean;
    dispatch: AppThunkDispatch;
}

interface ReduxDispatchProps {
    appActions: typeof Actions;
    appServiceActions: AppService.ServiceActions;
}

type MapsProperties =
    ReduxStateProps
    & ReduxDispatchProps;

const Maps: React.FC<MapsProperties> = (Props) => {
    const initialState: MapsState = {
        geolocations: [],
        filteredGeolocations: [],
        showingInfoWindow: false,
        activeMarker: null,
        showDealers: true,
        showDealersCarWash: true,
        showBP: true,
        showBPCarWash: true,
        showHP: true,
    };
    const [state, setState]: [MapsState, React.Dispatch<any>] = useReducer(
        (oldState, newState) => ({ ...oldState, ...newState }), initialState,
    );

    const { t } = useTranslation();

    useEffect(() => {
        Props.appServiceActions.getGeolocations();
    }, []);

    useEffect(() => {
        if (Props.geolocations) {
            setState({
                geolocations: Props.geolocations,
                filteredGeolocations: Props.geolocations,
            });
        }
    }, [Props.geolocations]);

    interface MarkerProps {
        geoItem: GeolocationsDTO | null;

    }
    const MapMarker: React.FC<ChildComponentProps & MarkerProps> = (props) => {
        if (!props.geoItem) {
            return null;
        }
        const markerClass: any =
            !props.geoItem.isBMWCarWash && props.geoItem.isDealer ? css.mapMarkerBmw
                : props.geoItem.isBMWCarWash && props.geoItem.isDealer ? css.mapMarkerBmwWash
                    : !props.geoItem.isBMWCarWash && props.geoItem.isBP ? css.mapMarkerBp
                        : props.geoItem.isHP ? css.mapMarkerHp
                        : css.mapMarkerBpWash;
        return (
            <React.Fragment>
                <div className={markerClass} /* onMouseEnter={() => onMarkerMouseEnter(props.geoItem)} onMouseLeave={() => onMarkerMouseLeave()} */ onClick={() => onMarkerClick(props.geoItem)} />
            </React.Fragment>
        );
    };
    const MapInfoWindow: React.FC<ChildComponentProps & MarkerProps> = (props) => {
        if (!props.geoItem) {
            return null;
        }
        return (
            <div className={css.mapInfoWindow}>
                <div className={css.block1}>
                    <b>{props.geoItem.name}</b>
                </div>
                <div className={css.block2}>
                    {props.geoItem.address}
                </div>
                <div className={css.block3}>
                    {`${props.geoItem.postCode} ${props.geoItem.location}`}
                </div>
                <br />
                <a href={`${config.MapsRouteUrl}${props.geoItem.latitude},${props.geoItem.longitude}`} target="_blank" >{t('subscriptions:getRoute')}</a>
            </div>
        );
    };

    interface MapFilterItem {
        id: number;
        label: string;
        show: boolean;
    }
    const MapFilterItem: React.FC<MapFilterItem> = (props) => {
        // const colorClass: any = props.id === 1 ? css.primary : props.id === 2 ? css.red : props.id === 3 ? css.green : css.orange;
        const colorClass: any = props.id === 1 || props.id === 2 ? css.primary : props.id === 3 || props.id === 4 ? css.green : css.orange;
        return (
             <div className={css.relative}>
                <input type="checkbox" name={`cb${props.id}`} id={`cb${props.id}`} value="1" checked={props.show} onChange={() => OnMapFilterChange(props.id)} />
                <label htmlFor={`cb${props.id}`} className={classNames([css.checkbox, colorClass, css.oneline, props.show ? css.checked : null])}>{props.label}</label>
             </div>
        );
    };

    const MapFilters: React.FC<{}> = () => {
        return (
            <div className={css.mapControls}>
                <MapFilterItem id={1} label={t('subscriptions:landing.filter1')} show={state.showDealers} />
                <MapFilterItem id={2} label={t('subscriptions:landing.filter2')} show={state.showDealersCarWash} />
                <MapFilterItem id={3} label={t('subscriptions:landing.filter3')} show={state.showBP} />
                <MapFilterItem id={4} label={t('subscriptions:landing.filter4')} show={state.showBPCarWash} />
                <MapFilterItem id={5} label={t('subscriptions:landing.filter5')} show={state.showHP} />
            </div>
        );
    };

    function OnMapFilterChange(id: number) {
        let sDealers = state.showDealers;
        let sHP = state.showHP;
        let sBP = state.showBP;
        let sDealersCarWash = state.showDealersCarWash;
        let sBPCarWash = state.showBPCarWash;
        switch (id) {
            case 1:
                sDealers = !sDealers;
                setState({ showDealers: !state.showDealers });
                break;
            case 2:
                sDealersCarWash = !sDealersCarWash;
                setState({ showDealersCarWash: !state.showDealersCarWash });
                break;
            case 3:
                sBP = !sBP;
                setState({ showBP: !state.showBP });
                break;
            case 4:
                sBPCarWash = !sBPCarWash;
                setState({ showBPCarWash: !state.showBPCarWash });
                break;
            case 5:
                sHP = !sHP;
                setState({ showHP: !state.showHP });
                break;
            default:
        }
        const filteredGeolocations = state.geolocations.filter((x) =>
            (sDealers && x.isDealer === sDealers && !x.isBMWCarWash) ||
            (sDealersCarWash && x.isDealer && x.isBMWCarWash === sDealersCarWash) ||
            (sHP && x.isHP === sHP) ||
            (sBP && x.isBP === sBP && !x.isBMWCarWash) ||
            (sBPCarWash && x.isBP && x.isBMWCarWash === sBPCarWash),
        );
        setState({ filteredGeolocations });
    }

    // function onMarkerMouseEnter(geoItem: GeolocationsDTO | null) {
    //    setState({
    //        showingInfoWindow: true,
    //        activeMarker: geoItem,
    //    });
    // }

    // function onMarkerMouseLeave() {
    //    setState({
    //        showingInfoWindow: false,
    //    });
    // }

    function onMarkerClick(geoItem: GeolocationsDTO | null) {
        setState({
            showingInfoWindow: true,
            activeMarker: geoItem,
        });
    }

    function handleClick(e: ClickEventValue) {
        setState({
            showingInfoWindow: false,
        });
    }

    const defaultProps = {
        center: {
            lat: Number(config.MapsCenterLat),
            lng: Number(config.MapsCenterLng),
        },
        zoom: config.MapsZoom,
    };

    const mapOptions: MapOptions = {
        // mapTypeId: 'satellite',
        disableDefaultUI: false,
        clickableIcons: true,
        mapTypeControl: true,
        mapTypeControlOptions: {
            position: 3, // TOP_RIGHT
        },
    };

    function GetCenterCoords(): Coords {
        const coords: Coords = {
            lat: Number(config.MapsCenterLat),
            lng: Number(config.MapsCenterLng),
        };
        return coords;
    }

    return (
        <React.Fragment>
            <div className={css.mapBox}>
                <MapFilters />
                <GoogleMapReact
                    bootstrapURLKeys={{ key: config.MapsApiKey }}
                    defaultZoom={defaultProps.zoom}
                    defaultCenter={defaultProps.center}
                    yesIWantToUseGoogleMapApiInternals
                    options={mapOptions}
                    onClick={handleClick}
                    center={GetCenterCoords()}
                >
                    {
                        state.filteredGeolocations && state.filteredGeolocations.map((x: GeolocationsDTO, idx: any) => {
                            return <MapMarker
                                key={`marker${idx}`}
                                lat={x.latitude}
                                lng={x.longitude}
                                geoItem={x}
                            />;
                        })
                    }

                    {state.showingInfoWindow && <MapInfoWindow
                        lat={state.activeMarker ? state.activeMarker.latitude : 0}
                        lng={state.activeMarker ? state.activeMarker.longitude : 0}
                        geoItem={state.activeMarker}
                    />
                    }
                </GoogleMapReact>
            </div>
        </React.Fragment>
    );
};

const mapStateToProps = (store: RootState) => ({
    geolocations: store.appState.getGeolocations.geolocations,
    isCommunicatingGetGeolocations: store.appState.getGeolocations.isCommunicating,
});

const mapDispatchToProps = (dispatch: AppThunkDispatch) => ({
    appActions: bindActionCreators(Actions, dispatch),
    appServiceActions: AppService.bindServiceActionCreators(config, dispatch),
    dispatch,
});

export default connect(mapStateToProps, mapDispatchToProps)(Maps);
